<template>
  <div class="ma-4">
    <StaffNav class="hideOnPrint" />
    <v-card>
      <v-card-title style="background-color: #2b3990">
        <span class="headline white--text">{{ titleForm }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="3">
              <v-autocomplete
                label="Vehicle"
                v-model="items.VehicleType"
                :items="vehicles"
                prepend-icon="local_taxi"
              ></v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              sm="12"
              md="3"
              v-if="items.VehicleType === 'Other'"
            >
              <v-text-field
                v-model="items.OtherVehicleType"
                label="Other"
                prepend-icon="local_taxi"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field
                v-model="items.Start"
                label="Starting Miles"
                prepend-icon="speed"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field
                v-model="items.End"
                label="Ending Miles"
                prepend-icon="speed"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu
                ref="menu"
                v-model="menu"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="items.Date"
                    label="Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker v-model="items.Date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <!-- <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(date)"
                >
                    OK
                </v-btn> -->
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12">
              <h2>INTERIOR</h2>
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="4">
              <span>Current Registration and Insurance (Sealed Envelope):</span>
              <v-checkbox
                v-model="items.Registration"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Registration"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Gauges (any engine lights, dash lights on):</span>
              <v-checkbox
                v-model="items.Gauges"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Gauges"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Air Condition / Heat Working:</span>
              <v-checkbox
                v-model="items.Heater"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Heater"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Fire Extinguisher: </span>
              <v-checkbox
                v-model="items.Fire"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Fire"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>First Aid Kit: </span>
              <v-checkbox
                v-model="items.FirstAid"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.FirstAid"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>All Seatbelts Functional: </span>
              <v-checkbox
                v-model="items.Seatbelts"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Seatbelts"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Vehicle Clean Inside:</span>
              <v-checkbox
                v-model="items.Inside"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Inside"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Rear View Mirror: </span>
              <v-checkbox
                v-model="items.RearView"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.RearView"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>
            <v-col md="4"></v-col>

            <v-col cols="12">
              <h2>EXTERIOR</h2>
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="4">
              <span>Tire treads or crack on tires:</span>
              <v-checkbox
                v-model="items.TireTreads"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.TireTreads"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Vehicle Clean Outside:</span>
              <v-checkbox
                v-model="items.Outside"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Outside"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="3">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="items.CarWashDate"
                    label="Car Wash Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker v-model="items.CarWashDate" no-title scrollable>
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              <span>Any Damages to Exterior of Vehicle:</span>
              <v-checkbox
                v-model="items.Damage"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Damage"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" v-if="items.Damage == 'Yes'">
              <v-textarea
                outlined
                label="Damage Explanation"
                v-model="items.DamageExplanation"
              ></v-textarea>
            </v-col>

            <v-col cols="12" md="4">
              <span>Side Mirrors Intact and Working:</span>
              <v-checkbox
                v-model="items.Mirrors"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Mirrors"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Spare Tire:</span>
              <v-checkbox
                v-model="items.Spare"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Spare"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="8"></v-col>

            <v-col cols="12">
              <h2>MECHANICAL</h2>
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12" md="4">
              <span>Windows Clean and Wipers Functional: </span>
              <v-checkbox
                v-model="items.Windows"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Windows"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Reverse and Brake Lights Working:</span>
              <v-checkbox
                v-model="items.Reverse"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Reverse"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Hazard Lights Working:</span>
              <v-checkbox
                v-model="items.Hazard"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Hazard"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Head Lights Working:</span>
              <v-checkbox
                v-model="items.Lights"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Lights"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Turn Signals Working:</span>
              <v-checkbox
                v-model="items.Signals"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Signals"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Horn Working:</span>
              <v-checkbox
                v-model="items.Horn"
                value="Yes"
                label="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Horn"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span>Any Unexplained Puddles Under Vehicle:</span>
              <v-checkbox
                v-model="items.Puddles"
                label="Yes"
                value="Yes"
                dense
              ></v-checkbox>
              <v-checkbox
                v-model="items.Puddles"
                label="No"
                value="No"
                dense
              ></v-checkbox>
            </v-col>

            <v-col cols="12">
              <v-textarea
                label="Description of Activity"
                outlined
                v-model="items.Description"
              ></v-textarea>
            </v-col>

            <v-col cols="12" sm="6">
              <form enctype="multipart/form-data">
                <v-file-input
                  v-model="imageNames"
                  class="pa-2"
                  label="Upload Front, Left, Right, and Rear Images"
                  filled
                  multiple
                  prepend-icon="mdi-camera"
                  accept="image/*"
                  @change="imgSelected"
                  show-size
                >
                  <template #selection="{ text, index }">
                    <v-chip
                      small
                      label
                      close
                      color="primary"
                      @click:close="deleteChip(index)"
                      >{{ text }}</v-chip
                    >
                  </template>
                </v-file-input>
              </form>
            </v-col>
            <v-carousel v-if="documents.length > 0">
              <template v-for="(image, index) in documents">
                <v-carousel-item :key="index">
                  <v-row class="flex-nowrap" style="height: 80%">
                    <v-img :src="image.AWSLink">
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                      >
                        <div style="color: #000; padding-top: 30%">
                          {{ image.Name }}
                        </div>
                      </v-row>
                    </v-img>
                  </v-row>
                </v-carousel-item>
              </template>
            </v-carousel>
            <v-col class="d-flex" cols="12" sm="12">
              <template>
                <v-img :src="newImageLink" height="200px;"></v-img>
              </template>
            </v-col>

            <v-col cols="12">
              <v-checkbox
                label="Staff Check In Signature"
                v-model="items.CheckInSignature"
                @click="signCheckIn"
              ></v-checkbox>
              <v-text-field
                v-if="items.CheckInSignature"
                label="Staff Check In Signature"
                v-model="items.CheckIn"
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-checkbox
                label="Staff Check Out Signature"
                v-model="items.CheckOutSignature"
                @click="signCheckOut"
              ></v-checkbox>
              <v-text-field
                v-if="items.CheckOutSignature"
                label="Staff Check Out Signature"
                v-model="items.CheckOut"
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                label="Notes or Repair From Trip"
                outlined
                v-model="items.Notes"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#259647"
          class="white--text"
          @click="addInspection()"
          v-if="$route.params.action === 'add' && !isAuditorRole"
          >Save</v-btn
        >
        <v-btn
          fab
          small
          @click="showPrintModal()"
          class="mr-8 mb-2 white--text"
          color="#2b6993"
          elevation="4"
          v-if="$route.params.action === 'edit'"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          color="#2b6993"
          class="white--text"
          @click="updateVehicleInspection()"
          v-if="$route.params.action === 'edit' && !isAuditorRole"
          >Update
        </v-btn>
        <v-btn color="blue darken-1" text @click="cancel()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <Foot class="hideOnPrint" />
  </div>
</template>

<script>
import axios from "axios";
const url = require("@/client_config/config").url;
import Foot from "@/components/Footer";
import StaffNav from "@/components/StaffNav";
import PrintUtil from "../../../../utils/print-util";

export default {
  components: {
    Foot,
    StaffNav,
    // VehicleInspectionForm,
  },
  data: () => ({
    items: {},
    vehicles: [],
    menu: false,
    menu2: false,
    uploadImg: "",
    newImageLink: "",
    checkInSignature: false,
    checkOutSignature: false,
    newNotes: "",
    removedDocuments: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    requiredField: [(v) => !!v || "This is required"],
    state: localStorage.getItem("userState"),
    documents: [],
    mode: "add",
    imageNames: [],
    token: localStorage.getItem("token"),
  }),
  methods: {
    imgSelected(e) {
      this.uploadImg = e;
    },

    signCheckIn() {
      this.items.CheckIn = localStorage.getItem("Name") + " - " + new Date();
    },

    signCheckOut() {
      this.items.CheckOut = localStorage.getItem("Name") + " - " + new Date();
    },

    async updateVehicleInspection() {
      try {
        axios.put(`${url}/inspections/${this.items._id}`, {
          ...this.items,
          StaffID: this.$route.params.employeeID,
        });
        if (this.uploadImg != 0) {
          this.saveImg();
        }
        if (this.removedDocuments.length > 0) {
          this.deleteImages();
        }
        this.$router.push({
          path: `/VehicleInspection/${this.$route.params.employeeID}`,
        });
      } catch (e) {
        console.log(e);
      }
    },

    async addInspection() {
      try {
        console.log({itemsInAdd: this.items});
        const response = await axios.post(`${url}/inspections`, {
          ...this.items,
          StaffID: this.$route.params.employeeID,
        });

        this.inspectionID = response.data._id;

        if (this.uploadImg != 0) {
          this.saveImg();
        }

        this.$router.push({
          path: `/VehicleInspection/${this.$route.params.employeeID}`,
        });
      } catch (e) {
        console.log(e);
      }
    },

    saveImg() {
      for (let i = 0; i < this.uploadImg.length; i++) {
        this.uploadFiles(this.uploadImg[i]);
      }
    },

    uploadFiles(file) {
      const formData = new FormData();
      formData.append("vehicle-inspection-img", file);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      axios
        .post(
          `${url}/inspections/imguploader/${this.inspectionID}`,
          formData,
          ct
        )
        .then((res) => {
          console.log(res);
          //this.documents.push(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    cancel() {
      this.$router.push({
        path: `/VehicleInspection/${this.$route.params.employeeID}`,
      });
    },

    closeComponent(data) {
      this.$emit("closeVehicleInspectionForm", data);
    },

    deleteChip(index) {
      this.removedDocuments.push(this.documents[index]);
      this.documents.splice(index, 1);
    },

    deleteImages() {
      this.removedDocuments.forEach((document) => {
        console.log(document);
        axios
          .delete(`${url}/documents/${document._id}`)
          .then((res) => {
            if (res.status === 204) {
              console.log(document._id + " has been deleted.");
            }
            const documentIndex = this.returnVehicleDocuments.findIndex(
              (returnDocument) => returnDocument._id === document._id
            );
            this.returnVehicleDocuments.splice(documentIndex, 1);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    getVehicles() {
      axios.get(`${url}/vehicles/active/${this.state}`).then((res) => {
        this.vehicles = res.data.vehicles
          .map(
            (vehicle) =>
              `${vehicle.Year + " " + vehicle.Make + " " + vehicle.Model}`
          )
          .sort();
      });
    },

    async getInspections() {
      try {
        const response = await axios.get(
          `${url}/inspections/${this.$route.query.id}`
        );

        this.items = response.data.inspection;
        console.log({items : this.items});
        if (this.items.documents) {
          this.documents = this.items.documents;
          this.imageNames = this.documents.map((image) => {
            return { name: image.Name };
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    async printItem() {
      document.getElementById("printItem").style.display = "block";
      window.print();
      document.getElementById("printItem").style.display = "none";
    },

    async showPrintModal() {
      PrintUtil.showPrintOption(
        this.generateDownloadUrl,
        this.inspectionID,
        this.token,
        "VehicleInspection"
      );
    },
  },
  computed: {
    showOtherOption() {
      if (this.item.VehicleType === "Other") return true;
      return false;
    },
    titleForm() {
      if (this.$route.params.action === "edit") {
        return "Viewing Inspection";
      }

      return "New Inspection";
    },
    staffName() {
      return localStorage.getItem("Name")
        ? localStorage.getItem("Name")
        : this.$store.state.staff.staff?.Name;
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === "Auditor";
    },

    generateDownloadUrl() {
      return `${url}/inspections/printPdf/${this.inspectionID}`;
    },
  },
  created() {
    this.getVehicles();

    if (this.$route.query?.id) {
      this.inspectionID = this.$route.query?.id;
      this.getInspections();
    }
  },

  async mounted() {
    window.addEventListener("keydown", async (event) => {
      PrintUtil.handleKeydown(
        event,
        this.generateDownloadUrl,
        this.inspectionID,
        this.token,
        "VehicleInspection"
      );
    });
  },

  beforeDestroy() {
    window.removeEventListener("keydown", (event) => {
      PrintUtil.handleKeydown(
        event,
        this.generateDownloadUrl,
        this.inspectionID,
        this.token,
        "VehicleInspection"
      );
    });
  },
};
</script>
